import { render, staticRenderFns } from "./dialogTips.vue?vue&type=template&id=6e3117b1&scoped=true"
import script from "./dialogTips.vue?vue&type=script&lang=js"
export * from "./dialogTips.vue?vue&type=script&lang=js"
import style0 from "./dialogTips.vue?vue&type=style&index=0&id=6e3117b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3117b1",
  null
  
)

export default component.exports